/**
 * Public contact API. POST /api/contact persists a ContactRequest row
 * (see backend/app/routes/meetings.py). The endpoint is unauthenticated.
 */

import api from "./api";

export interface ContactInput {
  name: string;
  email: string;
  phone?: string;
  category?: string;
  budget?: string;
  message?: string;
  marketing_opt_in?: boolean;
}

export const contactService = {
  submit: async (payload: ContactInput): Promise<{ id: string }> => {
    const { data } = await api.post<{ id: string }>("/contact", payload);
    return data;
  },
};
